import { CoreButton, CoreModalDialogFooter } from '@components'
import TrashIcon from '@images/icons/trash-modal.svg?react'
import { toastSuccess } from '@utils'
import { useDeleteApprovalMatrixMutation } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useContext } from 'react'

import './deleteMatrixModal.scss'

export const DeleteMatrixModal = ({ reload, department }: { reload: () => void; department: any }) => {
  const { modalHide } = useContext(GlobalContext)

  const [deleteApprovalMatrix, { isLoading: isDeleting, error: deleteApprovalMatrixError }] =
    useDeleteApprovalMatrixMutation()

  const onDelete = async () => {
    try {
      await deleteApprovalMatrix({ departmentId: department?.id }).unwrap()
      reload?.()
      toastSuccess(
        tr('FRONTEND.USERS_MANAGEMENT.DELETE_MATRIX_DETAILS.SUCCESS', 'Approval matrix deleted successfully')
      )
      modalHide()
    } catch (error) {
      console.error('error: ', error)
    }
  }

  return (
    <div className='delete-matrix-modal'>
      <div className='delete-matrix-modal-icon'>
        <TrashIcon />
      </div>

      <div className='delete-matrix-modal-title'>
        {tr(
          'FRONTEND.USERS_MANAGEMENT.DELETE_MATRIX_DETAILS.TITLE',
          'Are you sure you want to delete custom approval matrix for department'
        )}
        : <b>{department?.departmentName}</b>.
      </div>
      <div className='delete-matrix-modal-description'>
        {tr(
          'FRONTEND.USERS_MANAGEMENT.DELETE_MATRIX_DETAILS.DESCRIPTION',
          'Deleting this matrix will remove the structured approval flow for this department. Expense requests will no longer follow a predefined approval hierarchy and will instead be routed based on general approval permissions.'
        )}
      </div>

      <ErrorDisplay error={[deleteApprovalMatrixError]} />

      <CoreModalDialogFooter>
        <div className='delete-matrix-modal-footer'>
          <CoreButton
            size='large'
            text={tr('FRONTEND.USERS_MANAGEMENT.DELETE', 'Delete')}
            fullWidth
            onClick={onDelete}
            isLoading={isDeleting}
            disabled={isDeleting}
          />
          <CoreButton
            size='large'
            text={tr('FRONTEND.USERS_MANAGEMENT.CANCEL', 'Cancel')}
            variation='tertiary'
            onClick={modalHide}
            isLoading={isDeleting}
            disabled={isDeleting}
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}
